<template>
  <!--NEW MENU - TOP BUTTONS-->
  <div class="uk-width-1-1" style="padding: 0;">
    <div style="background-color: #F6DF98; padding: 10px;">
      <div class="uk-grid uk-grid-large gridcenter1200" style="padding: 0;max-width: 1140px;"  >
        <div :class="`${(is_az)?'uk-width-1-4@s':'uk-width-1-5@s'}`" style="padding: 0 5px;margin-bottom: 10px" v-if="text_search_done || is_az">
          <a @click="reset_search" uk-toggle="target: #schedule-search" style="text-decoration: none;"><div class="button-schedule-top">main schedule</div></a>
        </div>
        <div :class="`${(text_search_done)?'uk-width-1-5@s':'uk-width-1-4@s'} uk-visible@s`" style="padding: 0 5px;">
          <a href="https://www.pbs12.org/schedule/highlights/?new_menu=1" style="text-decoration: none;"><div class="button-schedule-top">highlights</div></a>
        </div>
        <div v-if="!is_az" :class="`${(text_search_done)?'uk-width-1-5@s':'uk-width-1-4@s'} uk-visible@s`" style="padding: 0 5px;">
          <a @click="to_az" style="text-decoration: none;"><div class="button-schedule-top">programs A-Z</div></a>
        </div>
        <div :class="`${(text_search_done)?'uk-width-1-5@s':'uk-width-1-4@s'} uk-visible@s`" style="padding: 0 5px;">
          <a href="https://www.pbs12.org/schedule/printable-grid/" style="text-decoration: none;"><div class="button-schedule-top">printable grid</div></a>
        </div>

        <div :class="`${(text_search_done)?'uk-width-1-5@s':'uk-width-1-4@s'}`" style="padding: 0 5px;">
          <a @click="toggle_search_on" style="text-decoration: none;"><div id="search-schedule-top-button" class="button-schedule-top">search schedule</div></a>
          <div id="invisible-toggle-search-off" @click="toggle_search_off"></div>
        </div>

        <!--
        {{text_search_done}}
        {{search_input}}
        -->
        <div id="schedule-search" class="uk-grid uk-hidden"  style="width: 100%;margin:0;padding:0;">
          <div class="uk-width-1-2@s uk-visible@m" id="schedule-search-1" style="padding: 5px 5px;" >
            &nbsp;
          </div>
          <div  class="uk-width-1-2@s" id="schedule-search-2" style="padding: 15px 5px 5px 5px;" >
            <input v-model="search_input"
                   v-on:keyup.enter="text_search"
                   placeholder="enter a program or episode title"
                   class="select-pbs-schedule-search-input2" style="width: 100%;">
          </div>
        </div>

      </div>

    </div>
    <!--
    <div style="background-color: #F8EECA; padding: 10px;">
      <div class="gridcenter1200" style="padding: 25px 10px 10px;">

          <div class="all-air-dates-progtitle" style="float: left;">PROGRAMS A-Z</div>
          <div class="" style="float: right; color: black; font-size: 22px; font-family: Avenir-Heavy;">FEB 10 - APR 25</div>
          <div style="clear: both; margin-bottom: 10px;"></div>

        <div class="uk-grid uk-grid-small">
          <div class="uk-width-1-2@s">
            <select placeholder="" class="select-pbs-schedule-search-input3" style="width: 100%;">
              <option value="1">filter by channel</option>
            </select>
          </div>
          <div class="uk-width-1-2@s">
            <select placeholder="" class="select-pbs-schedule-search-input3" style="width: 100%;">
              <option value="1">filter by genre</option>
            </select>
          </div>
        </div>

      </div>
    </div>

    <div style="background-color: white; padding: 10px;">
      <div class="gridcenter1200" style="padding: 25px 10px 10px;">
        <div class="all-air-dates-progtitle">ANTIQUE</div>
        <div style="font-size: 16px; color: grey; font-family: Avenir-Medium;">is on <span style="color: #00AEB4;">CHANNEL 12.1</span></div>
      </div>
    </div>
   -->
  </div>
</template>

<script>

import {mapGetters, mapActions} from "vuex"
import uk from "uikit";
import $ from "jquery"
// import uk from 'uikit'

export default {
  name: "TopNavigationBar",
  props:['search_type'],
  data(){
    return {
      search_input: ''
    }
  },
  computed:{
    ...mapGetters(['channel','text_search_input','server_info','text_search_done']),
    is_az() {
      return this.$route.name.match(/programs_az/);
    }
  },
  created() {
    this.$watch("text_search_input", () => {
      if( this.text_search_input === null && this.search_input !== ''){
        this.search_input = ''
      }
    })
    this.$watch("text_search_done", () =>{
        if(this.text_search_done){
          this.search_input = this.text_search_input
        }else{
          this.search_input = ''
        }
      }, { immediate: true })
  },
  mounted() {
    uk.scroll('#bottom_app_div', {offset: 0}).scrollTo('#app')
  },
  methods:{
    ...mapActions(['changeCurrentChannel','searchInputData']),
    to_az(){
      this.changeCurrentChannel(-1)
      this.searchInputData(null)
      // uk.scroll('#bottom_app_div', {offset: 100}).scrollTo('#app')
      this.$router.push({
        name: 'programs_az', params: { '_channel': this.channel, type: '1', _search_query: this.text_search_input,_current_day:undefined, exact_match:undefined }
      })
    },
    toggle_search_off(){
      // if($('#schedule-search').classList.value.indexOf('uk-hidden') >= 0){ $('#schedule-search').removeClass('uk-hidden')}
      // if(!$('#schedule-search').attr('hidden')){
      console.log($('#schedule-search').classList)
      if(!$('#schedule-search').hasClass('uk-hidden')){
        console.log('on toggle off')
        $('#schedule-search').addClass('uk-hidden')
      }
    },
    toggle_search_on(){
      //if(!$('#schedule-search').attr('hidden')){
        //console.log('on click')
      // if($('#schedule-search').attr('hidden')){
      console.log($('#schedule-search').classList)
      if($('#schedule-search').hasClass('uk-hidden')){
        console.log('on toggle on')
        uk.scroll('#bottom_app_div', {offset: 0}).scrollTo('#app')
        setTimeout( () => {
          //uk.toggle('#schedule-search').toggle()
          $('#schedule-search').removeClass('uk-hidden')
        }, 800)
      }
    },
    to_grid(){
      this.changeCurrentChannel(-1)
      this.searchInputData('')
      console.log('to grid:', { name: 'schedule', params: { _channel: '-1', type: '1',
          _current_day:undefined, exact_match:undefined
        }})
      this.$router.push({
        name: 'schedule', params: { _channel: '-1', type: '1',
          _current_day:undefined, exact_match:undefined
        }
      })
    },
    reset_search(){
      console.log('on reset')
      this.searchInputData(null)
      this.$router.push({ name: 'schedule', params: { 'type': 1, '_channel': 1, _current_day: this.server_info.date}})
    },
    text_search(){
      if(this.search_input !== ''){
        this.searchInputData(encodeURIComponent(this.search_input) == undefined ? this.search_input:encodeURIComponent(this.search_input))
      }
      this.changeCurrentChannel(-1)
      console.log('search: ',{ name: 'schedule', params: { 'type': this.search_type, '_channel': this.channel, _current_day: this.text_search_input }})
      this.$router.push({ name: 'schedule', params: { 'type': this.search_type, '_channel': this.channel, _current_day: this.text_search_input }})
    },
  }
}
</script>

<style scoped>

</style>